import { forwardRef } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { controlShellVariants } from '../../control-shell'
import { inputStyles } from '../../input'

const multipleInputStyles =
  'text-foreground placeholder:text-foreground-placeholder relative flex w-full outline-none disabled:cursor-not-allowed disabled:text-foreground-disabled flex-1 border-0 bg-transparent p-1 text-sm focus:border-0 focus:bg-transparent'

export interface ComboboxInputProps extends Combobox.Input.Props {
  className?: string
  variant?: 'single' | 'multiple'
}

/** forwardRef because callers focus this field. See `PartProps`. */
const ComboboxInput = forwardRef<HTMLInputElement, ComboboxInputProps>(function ComboboxInput(
  { variant = 'single', className, ...props },
  ref,
) {
  // The multiple variant is a bare field inside a chip row, so it takes no shell of its own.
  const styles = variant === 'multiple' ? multipleInputStyles : twMerge(inputStyles, controlShellVariants())
  return <Combobox.Input ref={ref} className={twMerge(styles, className)} {...props} />
})

export { ComboboxInput }
